module.exports = {}



// WEBPACK FOOTER //
// ./src/lang/i18nJP.js